import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'Alejandro M.',
  city: 'Buenos Aires'
}, {
  name: 'Camila R.',
  city: 'Mendoza'
}, {
  name: 'Facundo L.',
  city: 'Córdoba'
}, {
  name: 'Valentina S.',
  city: 'Rosario'
}, {
  name: 'Nicolás P.',
  city: 'Tucumán'
}, {
  name: 'Sofía D.',
  city: 'La Plata'
}, {
  name: 'Matías G.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta B.',
  city: 'Salta'
}, {
  name: 'Tomás H.',
  city: 'Santa Fe'
}, {
  name: 'Florencia K.',
  city: 'Neuquén'
}];
function getRandomTime() {
  return `hace ${Math.floor(Math.random() * 15) + 1} min`;
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  useEffect(() => {
    const showToast = () => {
      setCurrentBuyer(Math.floor(Math.random() * buyers.length));
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialDelay = setTimeout(showToast, 8000);
    const interval = setInterval(showToast, 18000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  const buyer = buyers[currentBuyer];
  return <AnimatePresence data-id="element-193">
      {visible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-6 left-6 z-50 bg-card border border-white/10 rounded-xl p-4 shadow-2xl max-w-xs backdrop-blur-sm" data-id="element-194">
          <div className="flex items-center gap-3" data-id="element-195">
            <div className="w-10 h-10 rounded-full bg-accent-cyan/20 flex items-center justify-center shrink-0" data-id="element-196">
              <ShoppingBag className="w-5 h-5 text-accent-cyan" data-id="element-197" />
            </div>
            <div data-id="element-198">
              <p className="text-white text-sm font-semibold" data-id="element-199">
                {buyer.name}{' '}
                <span className="text-gray-400 font-normal" data-id="element-200">
                  de {buyer.city}
                </span>
              </p>
              <p className="text-accent-yellow text-xs font-medium" data-id="element-201">
                Compró el Kit de Serigrafía PRO · {getRandomTime()}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}